import { ENDPOINTS } from "config/endpoints";
import client from "utils/client";
import { useQuery } from "react-query";
import { Request } from "types/request";
import { Response } from "types/response";
import { Block } from "types/block";
import Error from "types/error";
import { generatePath } from "react-router-dom";

export default function useBlockOwnerInfo(id: string, enabled = true) {
  const request: Request = {
    url: generatePath(ENDPOINTS.block.ownerInfo, { id }),
    config: {
      method: "GET",
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.block.ownerInfo, id],
    queryFn: () => client(request),
    enabled: !!id && enabled,
  };

  const { data, ...rest } = useQuery<Response<Block>, Error>(requestConfig);

  return { data, ...rest };
}
